<template>
	<div class="pageloading-wrapper">
		<div class="pageLoading" :class="[white ? 'pageLoading--white': '']"></div>
	</div>
</template>

<script>
export default {
	name: 'PageLoading',
	props: {
		white: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
.pageloading-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	height: 50vh;
	.pageLoading {
		box-sizing: border-box;
		display: inline-block;
		width: 100px;
		height: 100px;
		border: 6px solid rgba(4, 190, 251, 0.1);
		border-radius: 50%;
		border-top-color: #59bdf6;
		animation: spin 1s ease-in-out infinite;
		-webkit-animation: spin 1s ease-in-out infinite;
		&--white{
			border: 6px solid rgba(255, 255, 255, 0.1);
			border-top-color: white;
		}
	}

	/* Safari 4.0 - 8.0 */
	@-webkit-keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}

	/* Standard syntax */
	@keyframes spin {
		from {
			transform: rotate(0deg);
		}
		to {
			transform: rotate(360deg);
		}
	}
}
</style>
